import DivComponent from "../components/div";
import ParagraphComponent from "../components/paragraph";
import {isInteger} from "../utils/is-integer";
import {RenderPosition, render} from "../utils/render";

export default class StockController {
  constructor({className = ``, cityP = ``, stockCount = 0, deliveryDate = ``}) {
    this._className = className;
    this._cityP = cityP;
    this._stockCount = stockCount;
    this._deliveryDate = deliveryDate;
  }

  render(container) {
    const wrapComponent = new DivComponent(`${this._className}__itemStoreWrap`);
    render(container, wrapComponent.getElement(), RenderPosition.BEFOREEND);

    this._renderInStock(wrapComponent.getElement());
    this._renderDeliveryDate(wrapComponent.getElement());
  }

  _renderInStock(container) {
    if (!this._stockCount) {
      return;
    }

    const text = new ParagraphComponent({
      className: `${this._className}__itemStore`,
      text: `В наличии в ${this._cityP}, ${this._getStockCountText()}`,
    });

    render(container, text.getElement(), RenderPosition.BEFOREEND);
  }

  _renderDeliveryDate(container) {
    if (!this._deliveryDate) {
      return;
    }

    const text = new ParagraphComponent({
      className: `${this._className}__itemDate`,
      text: `Склад, поступление ${this._deliveryDate}`,
    });

    render(container, text.getElement(), RenderPosition.BEFOREEND);
  }

  _getStockCountText() {
    if (isInteger(this._stockCount) && +this._stockCount) {
      return `${this._stockCount} шт.`;
    }

    return ``;
  }
}
